<p-menu
  popup
  [model]="items()"
  [appendTo]="appendTo()"
  [styleClass]="resolvedStyleClass()"
  (onShow)="opened.emit()"
  (onHide)="closed.emit()"
>
  <ng-template
    #item
    let-item
  >
    @if (item.routerLink) {
      <a
        class="app-menu-item"
        routerLinkActive="app-menu-item_active"
        [class.app-menu-item_primary]="item.color === 'primary'"
        [class.app-menu-item_danger]="item.color === 'danger'"
        [routerLink]="item.routerLink"
        [queryParams]="item.queryParams"
        [target]="item.target"
      >
        <ng-container *ngTemplateOutlet="itemContent; context: { $implicit: item }" />
      </a>
    } @else if (item.url) {
      <a
        class="app-menu-item"
        [class.app-menu-item_primary]="item.color === 'primary'"
        [class.app-menu-item_danger]="item.color === 'danger'"
        [attr.href]="item.url"
        [attr.target]="item.target"
      >
        <ng-container *ngTemplateOutlet="itemContent; context: { $implicit: item }" />
      </a>
    } @else {
      <button
        type="button"
        class="app-menu-item"
        [class.app-menu-item_primary]="item.color === 'primary'"
        [class.app-menu-item_danger]="item.color === 'danger'"
      >
        <ng-container *ngTemplateOutlet="itemContent; context: { $implicit: item }" />
      </button>
    }
  </ng-template>
</p-menu>

<ng-template
  #itemContent
  let-item
>
  @if (item.icon) {
    <svg
      class="app-menu-item__icon"
      [appIcon]="item.icon"
    />
  }
  <span class="app-menu-item__label">{{ item.label }}</span>
</ng-template>
